import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, showAccessDeniedAlert, showTokenExpiredAlert, getConfig } from "utils";

export const productReviewList = createAsyncThunk('review/list', async ({ product_id, navigate }) => {
    try {
        const res = await axios({
            method: 'GET',
            url: getConfig.API_URL + `review`,
            params: {
                product_id,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})

const review = createSlice({
    name: 'review',
    initialState: {
        review_rating: null,
        list: [],
        loading: false,
    },
    reducers: {
        clearReviews: (state) => {
            state.review_rating = null
            state.list = []
        },
    },
    extraReducers: (builder) => {
        builder.addCase(productReviewList.fulfilled, (state, action) => {
            if (action?.payload?.status === 200) {
                const data = action.payload.data.data;
                state.review_rating = data?.review_rating || null;
                state.list = data?.reviews || [];
            } else if (action?.payload?.status === 401) {
                showTokenExpiredAlert(action?.payload?.data?.message, action.meta.arg.navigate);
            } else if (action?.payload?.status === 403) {
                showAccessDeniedAlert(action.meta.arg.navigate)
            } else {
                state.review_rating = null
                state.list = []
            }
        });
    }
})

export const { clearReviews } = review.actions
export default review.reducer;